import { masterPrograms } from '@/mocks/masterCourseData';
import { useTranslation } from 'react-i18next';

const PROGRAM_COUNT = 4;
const programIndices = Array.from({ length: PROGRAM_COUNT }, (_, i) => i);

function splitParagraphs(value: string): string[] {
  return value.split(/\n{2,}/);
}

export default function MasterPrograms() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-primary-900 overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-accent-500/[0.03] rounded-full translate-x-1/3 -translate-y-1/3 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-500/[0.02] rounded-full -translate-x-1/3 translate-y-1/3 blur-3xl"></div>
      <div className="relative z-10 max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {splitParagraphs(t('coursesMaster.programs.label')).map((paragraph, i) => (
            <p key={i} className="text-accent-400/60 text-[13px] tracking-[0.2em] mb-5 font-label">
              {paragraph}
            </p>
          ))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-4">
            {t('coursesMaster.programs.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {splitParagraphs(t('coursesMaster.programs.subtitleEn')).map((paragraph, i) => (
            <p key={i} className="section-title-en text-accent-400/50 text-sm tracking-[0.12em] mb-4">
              {paragraph}
            </p>
          ))}
          {splitParagraphs(t('coursesMaster.programs.lead')).map((paragraph, i) => (
            <p key={i} className="text-[17px] text-foreground-300 leading-relaxed tracking-[0.04em] max-w-xl mx-auto">
              {paragraph}
            </p>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {programIndices.map((index) => (
            <div key={index} className="p-7 border border-white/10 bg-white/[0.03] group hover:border-accent-500/30 hover:bg-accent-500/[0.05] transition-all duration-300 flex flex-col">
              <span className="w-11 h-11 mb-5 flex items-center justify-center">
                <i className={`${masterPrograms[index]?.icon} text-accent-400 text-2xl group-hover:text-accent-300 transition-colors duration-300`}></i>
              </span>
              {splitParagraphs(t(`coursesMaster.programs.${index}.titleEn`).toUpperCase()).map((paragraph, i) => (
                <p key={i} className="text-[12px] text-accent-400/50 tracking-[0.15em] mb-2 font-label">
                  {paragraph}
                </p>
              ))}
              <h3 className="font-heading text-[16px] text-foreground-100 tracking-[0.06em] mb-3">
                {t(`coursesMaster.programs.${index}.title`)}
              </h3>
              {splitParagraphs(t(`coursesMaster.programs.${index}.details`)).map((paragraph, i) => (
                <p key={i} className="text-[15px] text-foreground-400 leading-relaxed tracking-[0.03em] mb-4 flex-1">
                  {paragraph}
                </p>
              ))}
              {splitParagraphs(t(`coursesMaster.programs.${index}.note`)).map((paragraph, i) => (
                <p key={i} className="text-[13px] text-foreground-500 tracking-[0.04em]">
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
